/*
 * @Description: 联系人接口
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-18 21:37:09
 * @LastEditTime: 2019-07-24 14:55:44
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 联系人查询
export const getContactsList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/getDemand`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findDemandBy'
      }, params))
    }
  })
}
// 联系人新增-公司接口
export const getCustomerList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/get`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageDemand'
      }, params))
    }
  })
}
// 联系人新增-公司下拉回显
export const customerListEcho = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/getCustome`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getCustome'
      }, params))
    }
  })
}
// 联系人新增-提交
export const AddList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/saveCall`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'addCallLog'
      }, params))
    }
  })
}

// 推荐列表
export const recommendList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/contact`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'referral'
      }, params))
    }
  })
}
// 推荐列表-模糊查询
export const queryrecommendList = (params, data) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/getContact`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getReferral'
      }, params, data))
    }
  })
}
// 推荐列表-推荐提交
export const recommendedSub = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/referralGet`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'referralGet'
      }, params))
    }
  })
}

// 表格编辑保存
export const editContactsList = (params, data) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/saveCall`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandEdit',
        data
      }, params))
    }
  })
}
// 添加记录-获取联系记录
export const getContactRecord = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/getRecord`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getRecord'
      }, params))
    }
  })
}
// 添加记录-修改（保存）
export const determineRecords = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Record/RecordApi/updata`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'updata'
      }, params))
    }
  })
}
// 添加记录-提交按钮
export const addRecordsSub = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Record/RecordApi/saveCall`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'addCallLog'
      }, params))
    }
  })
}

// 删除联系人
export const deleteContactsList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/delete`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandRemove'
      }, params))
    }
  })
}
// 删除记录
export const delRecorde = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Record/RecordApi/batchDel`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'batchDel'
      }, params))
    }
  })
}
// 批量删除联系人
export const deleteBatchContactsList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/batchDel`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'batchDel'
      }, params))
    }
  })
}
